var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock"},[_c('div',{staticClass:"lefttime"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"date"},[_c('div',{staticClass:"day"},[_vm._v(_vm._s(_vm.day))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }